<lms-modal #modalTagsSelector size="small">
  <div class="gl-popup__title">{{ 'students.tags.edit.modal.title' | translate }}</div>
  <div class="gl-popup__close" (click)="modalTagsSelector.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    *ngIf="count > 1"
    class="gl-popup__text margin-top-gap"
    [innerHtml]="'nouns.editTagsStudents' | translate : { numberOfStudents: count }"
  ></div>
  <div
    *ngIf="count === 1"
    class="gl-popup__text margin-top-gap margin-bottom"
    [innerHtml]="'nouns.editTagsStudent' | translate : { numberOfStudents: count }"
  ></div>

  <div>
    <lms-dynamic-form
      #tagsForm
      [questions]="questions"
      [action]="'students.edit-tags'"
      [options]="{ hideSubmit: true, showSpinnerUponSubmitting: false, disableCard: true }"
    >
    </lms-dynamic-form>
  </div>
  <div class="gl-popup__buttons padding-top__none">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalTagsSelector.close()"></gl-button>
    <gl-button
      color-primary
      [text]="'actions.saveChanges' | translate"
      [disabled]="!canSendForm(tagsForm)"
      (onClick)="confirmTags()"
    ></gl-button>
  </div>
</lms-modal>
